const getServerVueTable = (httpClient, filtering, sorting, paging, params) => {
  return httpClient
    .get(`server`, {
      params: {
        search: filtering ? filtering.query : null,
        fields: filtering ? filtering.fields.join() : null,
        sort: sorting ? sorting.by : null,
        order: sorting ? sorting.order : null,
        page: paging ? paging.page : null,
        limit: paging ? paging.perPage : null,
        ...params,
      },
    })
    .then((res) => res.data);
};

const addServer = (httpClient, server) => {
  return httpClient.post(`server`, server).then((res) => res.data);
};

const updateServer = (httpClient, server) => {
  return httpClient
    .patch(`server/${server.fingerprint}`, server)
    .then((res) => res.data);
};

const downloadServerFile = (httpClient, fingerprint) => {
  return httpClient({
    url: `download/server/${fingerprint}`,
    method: "GET",
    responseType: "blob",
  }).then((response) => {
    const filename =
      response.headers["content-disposition"].split("filename=")[1];
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

const getStatistics = (httpClient, fingerprint) => {
  return httpClient.get(`static/${fingerprint}`).then((res) => res.data);
};

const getServerHistoryVueTable = (
  httpClient,
  filtering,
  sorting,
  paging,
  fingerprint
) => {
  return httpClient
    .get(`history/${fingerprint}`, {
      params: {
        search: filtering ? filtering.query : null,
        fields: filtering ? filtering.fields.join() : null,
        sort: sorting ? sorting.by : null,
        order: sorting ? sorting.order : null,
        page: paging ? paging.page : null,
        limit: paging ? paging.perPage : null,
      },
    })
    .then((res) => res.data);
};

const getServer = (httpClient, fingerprint) => {
  return httpClient.get(`server/${fingerprint}`).then((res) => res.data);
};

export default {
  getServerVueTable,
  addServer,
  updateServer,
  downloadServerFile,
  getStatistics,
  getServerHistoryVueTable,
  getServer,
};
